import * as React from 'react';
import { cn } from '@/lib/utils';

/* shadcn/ui Input on Hangar tokens: 8 px radius, page background, 44 px tall on phones, 16 px text there (no iOS zoom). */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'h-9 w-full min-w-0 rounded-lg border border-input bg-background px-3 py-1 text-base text-foreground transition-[border-color,box-shadow] duration-150 outline-none placeholder:text-subtle hover:border-border-strong disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 max-sm:h-11 sm:text-sm',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
